import React/*, { Component }*/ from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getLoggedUser } from '../selectors/user.js'
import { getUser } from '../store/reducers/auth.js'
import { fetchingState } from './../helpers/hocs.js'


//роль для пользователя при авторизации по умолчанию
const defaultRole = 'user';

//HOC-компонент, который оборачивает Layout и служит прослойкой для получения данных пользователя
//до рендера всего приложения и установки роли на сайте
const wrapperContainer = (WrappedComponent) => {
    class HOC extends React.Component {
        constructor (props) {
            super(props)

            this.state = {
                showContent: false,
                role: null
            }

            this.changeRole = this.changeRole.bind(this);
            this.getRole = this.getRole.bind(this);
        }
        
        //метод который передаем во всплывающее окно выбор роли
        changeRole(newRole) {
            //метод для задания роли во всплывающем окне
            this.setState((state, props) => {
                if (newRole !== state.role) {
                    return {
                        role: newRole
                    }
                } else {
                    return {
                        role: state.role
                    }
                }
            })
        }

        //метод получения роли
        getRole(user) {
            //метод вызывается когда получаем данные о пользователе с бека
            //исходим из того, что роль по-умолчанию - пользователь
            let role;
            if (user && user.role && user.role.length > 0) {
                //role = this.props.user.role - если пользователь есть
                //возможно нужно будет обращаться к np.user.role если this.props.user === false
                //потому что getRole вызываем в componentWillReceiveProps
                role = user.role
            } else {
                //если роль не выбрали / не задавали - устанавливаем роль по умолчанию
                role = defaultRole;
            }
            return role;
        }

        componentWillMount() {
            this.props.getInitialDataUser();
        }

        componentWillReceiveProps(np) {
            // Не монтируем приложение, пока не завершился первый запрос auth/user.
            // Иначе deep-link на защищенную страницу может зафиксироваться в 404 до того,
            // как прилетит реальная роль пользователя.
            if (np.fetching.initial !== false) {
                return;
            }

            const newRole = np.user ? this.getRole(np.user) : 'unautorized';

            if (!this.state.showContent || this.state.role !== newRole) {
                this.setState(() => ({
                    showContent: true,
                    role: newRole
                }));
            }
        }

        render() {
            if (typeof window !== 'undefined' && this.state.showContent) {
                return (
                    <WrappedComponent
                        role={this.state.role}
                        user={this.props.user}
                        changeRole={this.changeRole}
                    />
                );
           }
            return null;
        }
    }

    const mapStateToProps = state => ({
        user: getLoggedUser(state),
    })

    const mapDispatchToProps = dispatch => bindActionCreators({ getUser }, dispatch)

    const mergeProps = (state, dispatch, props) => ({
        ...props,
        ...state,
        getInitialDataUser: async () => {
            const getData = () => Promise.all([
                dispatch.getUser(),
            ])
            return props.fetchingWrap(getData.bind(this), 'initial')
        }
    })

    return fetchingState({ multi: true })(connect(mapStateToProps, mapDispatchToProps, mergeProps)(HOC));
};

export default wrapperContainer;



// WEBPACK FOOTER //
// ./src/containers/Wrapper.jsx